import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';

import './styles.css';

const NumberField = ({
  input: {onChange, onBlur, value},
  disabled,
  placeholder,
  className,
  min,
  step,
  meta: {touched, error}
}: any) => {
  return (
    <div className="NumberField">
      <input
        onChange={onChange}
        onBlur={onBlur}
        className={classNames({error: touched && error}, {disabled}, className)}
        placeholder={placeholder}
        type="number"
        value={value}
        disabled={disabled}
        min={min || '0'}
        step={step || 'any'}
      />
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default NumberField;
